import React from "react";
import SFTypography from "../typography";
import Box from "@mui/material/Box";

import useStyled from "../../hooks/useStyled";
const { styled } = useStyled();

const ContainerStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== "maxLines" && prop !== "scrollable",
})(({ theme, maxLines, scrollable}) => ({
  paddingRight: theme.spacing(2),
  overflowY: scrollable ? "auto" : "hidden",
  maxHeight: scrollable ? `calc(19px * ${maxLines})` : "none", // 19px is the default line height
  wordWrap: "break-word",
  ...(!scrollable && {
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: maxLines,
    lineClamp: maxLines,
    WebkitBoxOrient: "vertical",
  }),
}));

export const SFContent = ({ children, maxLines = 80, scrollable = false }) => (
  <ContainerStyled maxLines={maxLines} scrollable={scrollable}>
    <SFTypography variant="body2">{children}</SFTypography>
  </ContainerStyled>
);
